import { defineMessages } from 'react-intl';

export default defineMessages({
    submissionSuccessful: {
        id: 'twia.policy.common.views.submission.successful.Submission Successful',
        defaultMessage: "Submission Successful"
    },
    policyIssuedMessage: {
        id: 'twia.policy.common.views.submission.successful.policyIssuedMessage',
        defaultMessage: 'The policy has been issued.'
    },
    policyMailedMessage: {
        id: 'twia.policy.common.views.submission.successful.policyMailedMessage',
        defaultMessage: "A copy of your policy will be mailed to you."
    },
    policyDescriptionClick: {
        id: 'twia.policy.common.views.submission.successful.description.policyDescriptionClick',
        defaultMessage: "Click "
    },
    policyDescriptionHere: {
        id: 'twia.policy.common.views.submission.successful.description.policyDescriptionHere',
        defaultMessage: "here"
    },
    policyDescriptionViewAndDownloadDocuments: {
        id: 'twia.policy.common.views.submission.successful.description.policyDescriptionViewAndDownloadDocuments',
        defaultMessage: " to review and download the following documents:"
    },
    policyDescriptionCDocumentList: {
        id: 'twia.policy.common.views.submission.successful.description.policyDescriptionCDocumentList',
        defaultMessage: `
        •  Declaration Page
        •  Policy Package
        •  Application`,
    },
    policyNumber: {
        id: "twia.policy.common.views.submission.successful.Policy Number",
        defaultMessage: "Policy Number"
    },
    policyEffectiveDate: {
        id: "twia.policy.common.views.submission.successful.Policy Effective Date",
        defaultMessage: "Policy Effective Date"
    },
    policyPeriod: {
        id: "twia.policy.common.views.submission.successful.Policy Period",
        defaultMessage: "Policy Period"
    },
    totalPremium: {
        id: "twia.policy.common.views.submission.successful.Total Premium including Credits and Surcharges",
        defaultMessage: "Total Premium including Credits and Surcharges"
    },
    paymentPlan: {
        id: "twia.policy.common.views.submission.successful.Payment Plan",
        defaultMessage: "Payment Plan"
    },
    paymentMethod: {
        id: "twia.policy.common.views.submission.successful.Payment Method",
        defaultMessage: "Payment Method"
    },
    paymentConfirmationNumber: {
        id: "twia.policy.common.views.submission.successful.Payment Confirmation Number",
        defaultMessage: "Payment Confirmation Number"
    },
    nextInstallmentAmount: {
        id: "twia.policy.common.views.submission.successful.Next Installment Amount",
        defaultMessage: "Next Installment Amount"
    },
    nextInstallmentDueDate: {
        id: "twia.policy.common.views.submission.successful.Next Installment Due Date",
        defaultMessage: "Next Installment Due Date"
    },
});